 //
 // レイアウト構成指定用データ
 //
 export const layoutClassTable = [
        [12,["card-col2s",2],["card-col2s",2]],
        [13,["card-col2p full",2],["card-col2p full",2]],
        [14,["card-col2p2r",4]],
        [39,["card-col2s",2],["card-col2s",2]],
        [40,["card-col2p",2],["card-col2p",2]],
        [41,["card-col3s",3],["card-col2s",2]],
        [42,["card-col3p",3],["card-col2p",2]],
        [43,["card-col3p",3],["card-col3p",3]],
        [44,["card-col3s",3],["card-col3s",3]],
        [45,["card-col3p",3],["card-col2p",2]],
        [52,["card-col2p",2],["card-col2p",2],["card-col2p",2]],
        [53,["card-col2p",2],["card-col2p",2],["card-col2p",2]],
        [54,["card-col3p2r",6]],
        [58,["card-col3s",3]],
        [64,["card-col3p",3]],
        [70,["card-col3p2r",5]]
]


// WEBPACK FOOTER //
// ./src/mixin/PLayout.js